import { hrefProvider } from './providers/href';

import type { NavigationProvider } from './types';

/**
 * 호스트 providers 끝에 hrefProvider 가 이미 포함되어 있는지 검사.
 * 동일 인스턴스 또는 동일 `name` 매칭으로 중복 추가 방지.
 */
export function hasHrefFallback(providers: NavigationProvider[]): boolean {
  return providers.some((p) => p === hrefProvider || p.name === 'href');
}

/**
 * provider chain 의 *첫 매칭 가능한* provider 에 `navigate(url, action)` 위임.
 * 모두 unavailable 이면 no-op (silent).
 *
 * `action` 식별자 전달 시 provider 가 action 별 전용 interface 호출 가능
 * (예: `nolBridgeProvider` 가 `'logo'` → `NolBridge.home()`).
 *
 * @returns navigate 호출에 성공했는지 여부 — 호출자가 fallback 분기 가능.
 */
export function applyProviderChain(providers: NavigationProvider[], url: string, action?: string): boolean {
  for (const p of providers) {
    if (!p.isAvailable()) continue;
    p.navigate(url, action);
    return true;
  }
  return false;
}
